import { Suspense, lazy } from 'react';

/**
 * Loaded through the MF runtime, never at build time (root CLAUDE.md rule 1).
 * `lazy` also keeps the PMS bundle out of the shell's entry chunk.
 */
const PmsEvaluationForm = lazy(() => import('clarixPms/EvaluationForm'));

/**
 * The evaluation form, CHROME-FREE — `/pms/my-team/:participantId` (observer) and
 * `/pms/my-evaluations/:participantId` (self).
 *
 * Mounted inside `WorkspaceShell` but OUTSIDE `AppShellLayout`, the same slot
 * `AppLauncher` occupies: the session and workspace are still validated, but no
 * rail and no top bar are drawn.
 *
 * WHY these two paths are lifted out of the PMS remote's own router: everything
 * inside `clarixPms/App` renders within `AppShellLayout`, so the form arrived
 * wrapped in the whole application. The prototype opens it in its own tab with
 * nothing around it, and the tokenised link already does — reaching the same form
 * from My Team and getting a different frame made one form look like two products.
 *
 * The URLs are unchanged, so every existing link keeps working: these routes are
 * simply more specific than the `pms/*` splat and win the match.
 */
export function EvaluationStandalonePage({ mode }: { mode: 'self' | 'observer' }) {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center bg-muted/30">
          <span className="text-sm text-muted-foreground">Opening the evaluation…</span>
        </div>
      }
    >
      <PmsEvaluationForm mode={mode} />
    </Suspense>
  );
}
